var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',{staticStyle:{"background":"#e6e1e7"}},[(_vm.company.id != null)?_c('v-container',{attrs:{"fluid":""}},[(_vm.company.id != null)?_c('v-row',[_c('DCounts')],1):_vm._e()],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }